import styles from './HostServiceDetailHeading.module.css'
import { useReadHostServiceByMonitorIdQuery } from 'services/hostService'
import { DateTime } from 'luxon'
import { Skeleton } from '@mui/material'

interface HostServiceDetailHeadingProps {
    hostServiceId: number
    spyId?: number
}

export const HostServiceDetailHeading = (props: HostServiceDetailHeadingProps) => {
    const {
        hostServiceId = -1,
        spyId = -1
    } = props

    const readMonitorRunResultByMonitorIdQueryOptions = {
        refetchOnMountOrArgChange: true,
    }

    const readHostServiceByMonitorIdQueryParams = {
        monitorId: spyId,
        hostServiceId: hostServiceId,
        firstDay: DateTime.fromMillis(0).toSQLDate() || '',
        lastDay: DateTime.fromMillis(0).toSQLDate() || '',
    }

    const {
        data: readHostServiceByMonitorIdQueryData,
        isLoading: readHostServiceByMonitorIdQueryDataIsLoading,
        isFetching: readHostServiceByMonitorIdQueryDataIsFetching,
        error: readHostServiceByMonitorIdQueryError
    } = useReadHostServiceByMonitorIdQuery(readHostServiceByMonitorIdQueryParams, readMonitorRunResultByMonitorIdQueryOptions)
    
    const name = readHostServiceByMonitorIdQueryData?.name || undefined

    if (name === undefined){
        return (
            <div>
                <Skeleton sx={{height: '33px', width: '200px'}}/>
            </div>
        )
    }

    return (
        <div>
            <h2 className={styles.HostServiceDetailHeading__Name}>
                {name}
            </h2>
        </div>
    )
}